module.exports = __webpack_public_path__ + "img/hushed-face.e570e56d.png";